import { render } from "./BlFormFieldPhone.vue?vue&type=template&id=a28350c0&scoped=true"
import script from "./BlFormFieldPhone.vue?vue&type=script&lang=js"
export * from "./BlFormFieldPhone.vue?vue&type=script&lang=js"

import "./BlFormFieldPhone.vue?vue&type=style&index=0&id=a28350c0&scoped=true&lang=scss"

import exportComponent from "/tmp/6f278242-b890-433a-91e8-ee1cfc12c380/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a28350c0"]])

export default __exports__